/* @flow */
import { Map } from 'immutable';

type RawIndicator = {
  value: string,
  type: string,
  indicatorType: string,
};

type ImmutableIndicator = Map<string, string>;

// Normalize indicator like object
export const normalizeIndicatorShape = (indicatorLike: Object): Object => {
  const type = indicatorLike.indicatorType || indicatorLike.type;
  const value = indicatorLike.value;

  const enclaves = indicatorLike.enclaveIds ?
    indicatorLike.enclaveIds
    :
    indicatorLike.enclaveGuids
    ?
    indicatorLike.enclaveGuids
    :
    indicatorLike.enclaves;

  const occurrences = indicatorLike.sightings ? Map({[indicatorLike.sightings] : indicatorLike.sightings}) : Map({});

  return {
    ...indicatorLike,
    type,
    value,
    enclaves,
    occurrences,
    id: `${type}|${value}`,
  };
};

// Normalize indicator like Map object
export const normalizeIndicatorShapeImmutable = (indicatorLikeImmutable: any): ImmutableIndicator => {
  if (!indicatorLikeImmutable) return Map();
  return Map(normalizeIndicatorShape(indicatorLikeImmutable.toJS()));
};

// Creates the unique type|value ID for an indicator-like object
export const indicatorToId = (ioc: RawIndicator & ImmutableIndicator): string => {
  try {
    let type, value;

    if (Map.isMap(ioc)) {
      type = ioc.get('type');
      value = ioc.get('value');
    } else {
      type = ioc.type;
      value = ioc.value;
    }

    if (!type || !value) {
      throw new Error('Trying to generate indicator ID but indicator was invalid.');
    }

    return `${type}|${value}`;

  } catch (err) {
    console.error('Tried to generate an indicator ID with invalid input:', ioc);
    throw err;
  }
};



// WEBPACK FOOTER //
// ./src/app/modules/indicators/utils.js